import React, { useEffect, useRef } from 'react';
import { Button } from 'react-bootstrap';
import { ALL } from './overviewLists';
import './CoordinatorOverview.css';

/**
 * The sentence above a list an Overview link opened: how many rows, what they
 * have in common, the program and the term, so the coordinator sees why the
 * list matches the number they clicked. It takes focus when it appears, so a
 * keyboard or screen reader user lands on it rather than at the top of the
 * page.
 */
export default function ListFilterNote({
    show,
    list,
    count,
    programLabel,
    termName,
    noun,
    onClear,
}) {
    const ref = useRef(null);

    useEffect(() => {
        ref.current?.focus();
    }, [show]);

    const sentence =
        show === ALL
            ? `${termName}: showing all ${count} ${programLabel} ${list.phrase(count)}.`
            : `${termName}: showing the ${count} ${list.phrase(count)}.`;

    return (
        <div
            ref={ref}
            tabIndex={-1}
            className="list-filter-note d-flex flex-wrap align-items-center gap-2 border rounded bg-body-tertiary px-3 py-2 mb-3"
        >
            <span>{sentence}</span>
            {show !== ALL && (
                <Button
                    variant="link"
                    className="p-0 align-baseline"
                    onClick={onClear}
                >
                    {`Show all ${noun}`}
                </Button>
            )}
        </div>
    );
}
